import styled from "@emotion/styled";

import { color } from "metabase/lib/colors";

export const LoadingStateContainer = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  color: ${color("brand")};
`;
